module.exports = __webpack_public_path__ + "media/images/vgood_smiley-16dae68a83d69d9c9ef1da073e803941.svg";